export const DEFAULT_MIN_QUANTITY_PER_ORDER = 0;
export const DEFAULT_MAX_QUANTITY_PER_ORDER = 10;
export const DEFAULT_MIN_OPEN_PRICE = 0;
